// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function unflattenOptions(options) {
    const nestedOptions = [];
    let currentParent;
    options.forEach((option, index) => {
        var _a;
        if (option.type === 'parent') {
            const wrapped = { type: 'parent', option, index, children: [] };
            currentParent = wrapped;
            nestedOptions.push(wrapped);
        }
        else if (option.type === 'child') {
            ((_a = currentParent === null || currentParent === void 0 ? void 0 : currentParent.children) !== null && _a !== void 0 ? _a : nestedOptions).push({ type: 'child', option, index });
        }
        else {
            currentParent = undefined;
            nestedOptions.push({ type: 'child', option, index });
        }
    });
    return nestedOptions;
}
//# sourceMappingURL=unflatten-options.js.map